// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { CachedProjectItemBillingDeltaListProperty } from '@/audit/api/types';
import { AuditBillingEntriesList } from '@/audit/components/audit-cached-billing-delta-list-label';
import { Stack, Typography } from '@mui/material';

interface Props {
  property: CachedProjectItemBillingDeltaListProperty;
}

export function AuditCachedProjectBillingDeltaList(props: Props) {
  const entities =
    props.property.newValue?.sort((a, b) => {
      const aName = a.item?.name ?? '';
      const bName = b.item?.name ?? '';
      return aName.localeCompare(bName);
    }) ?? [];
  return (
    <Stack>
      <Typography component="span" variant="caption" fontWeight="bold">
        Billing periods:
      </Typography>
      {entities.map((entity) => {
        const periods = entity.periods;
        const item = entity.item;
        const productLineItemId = entity.productLineItemId;
        const quantity = entity.quantity;
        const unitPrice = entity.unitPrice;
        const itemName = item?.name;
        const billingEntries = [
          ...(periods.added?.map((row) => ({
            ...row,
            isNew: true,
          })) || []),
          ...(periods.removed?.map((row) => ({
            ...row,
            isNew: false,
          })) || []),
        ].sort((a, b) => {
          return a.date.toMillis() - b.date.toMillis();
        });
        return (
          <Stack sx={{ marginLeft: 2 }} key={productLineItemId}>
            <Typography component="span" variant="caption">
              {itemName} {quantity}
              {unitPrice && ' × ' + unitPrice}
            </Typography>
            <AuditBillingEntriesList entries={billingEntries} />
          </Stack>
        );
      })}
    </Stack>
  );
}
